import React, { Fragment, useEffect, useState } from "react";
import 'react-toastify/dist/ReactToastify.css';
import { Link , useNavigate } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
import { MaterialReactTable } from 'material-react-table'
import type { ColumnFiltersState, PaginationState } from '@tanstack/react-table';
import { PAGES } from '../../Constants/CommonConstants';
import { paginationQuery, handleSearch } from '../../utils/GlobalHelper';
import { getDate } from '../../utils/Helper';
import { StaffGetAction } from "../../Redux/Action/StaffAction";
import { FormattedMessage, useIntl } from "react-intl";

function StaffManagement() {
  const [data, setData] = useState<any>([]);

    const dispatch = useDispatch<any>();
    const intl = useIntl();
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);
    const [sorting, setSorting] = useState<any>(['DESC']);
    const Stafflist = useSelector((state: any) => state.StaffGetState);

  
  const [pagination, setPagination] = useState<PaginationState>({
      pageIndex: PAGES?.pageIndex,
      pageSize: PAGES?.pageSize
    });
    const [searchValue, setSearchValue] = useState('');
    const [rowCount, setRowCount] = useState(0);
    const log_in = useSelector((state: any) => state.AdminLogInState)

 useEffect(() => {
  const fetchData = async () => {
    if (!data?.length) {
      setLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      let query: any = paginationQuery(
        pagination.pageIndex,
        pagination.pageSize,
        sorting,
        searchValue,
        columnFilters
      );

      await dispatch(StaffGetAction(query));

    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setLoading(false);
    setIsRefetching(false);
  };
  fetchData();
}, [
  columnFilters,
  searchValue,
  pagination.pageIndex,
  pagination.pageSize,
  sorting
]);
useEffect(() => {
  setData(Stafflist?.data?.data?.rows);
  setRowCount(Stafflist?.data?.data?.count);
}, [Stafflist?.data]);

 const columns: any = [
  {
    accessorKey: 'S.NO',
    header: intl.formatMessage({ id: "s_no" }),
    accessorFn: (row: Object, index: number) => {
      const currentPage = pagination.pageIndex + 1 || 1;
      const itemsPerPage = pagination.pageSize || 10; 
      const startIndex = (currentPage - 1) * itemsPerPage;
      const serialNumber = startIndex + index + 1;
      return serialNumber;
    },
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
    size:50,
},
  {
    accessorKey: 'name',
    header: intl.formatMessage({ id: "name" }),
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'email',
    header: intl.formatMessage({ id: "email" }),
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'phone_number',
    header: intl.formatMessage({ id: "mobile" }),
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'country',
    header: intl.formatMessage({ id: "address" }),
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'bio',
    header: intl.formatMessage({ id: "services" }),
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false
  },
  {
    accessorKey: 'id',
    header: intl.formatMessage({ id: "total_done_services" }),
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false
  },
 
  {
    accessorKey: 'created_at',
    header: intl.formatMessage({ id: "created_at" }),
    accessorFn: (row: { created_at: any; }) => getDate(row.created_at),
    size: 150,
    filterVariant: 'date',
    enableSorting: false,
    enableColumnOrdering: false,
    enableColumnDragging: false,
    enableColumnFilter: false,
  },
];



    return (
        <Fragment>
            { loading || Stafflist?.loading ? <Spinner /> : ""}
            <PageLayout
        title={<FormattedMessage id="staff_management" />}
        breadcrumbs={{
          secLast: { 'link': '/staff-list', 'name': <FormattedMessage id="staff_management" /> },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >

     
      <div className="row gy-3 mb-3">
          <div className="col-md-6 ms-auto text-end"> 
          </div>
        </div>
        {
          data &&
          <MaterialReactTable

            columns={columns}
            data={data}
            enableGlobalFilter={false}

            enableHiding={false}
            enableColumnFilters={false}
            enableDensityToggle={false}
            enableColumnActions={false}
            enableFullScreenToggle={false}
            positionToolbarAlertBanner="top"
            initialState={{ showColumnFilters: false }}
            manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={isError ? { color: 'error', children: intl.formatMessage({ id: "error_loading_data" }), } : undefined}
            muiSearchTextFieldProps={{
              placeholder: intl.formatMessage({ id: "search_from_name" }),
            }}
            onColumnFiltersChange={setColumnFilters}
            onGlobalFilterChange={(value: any) => handleSearch(
              value,
              setIsError,
              setLoading,
              setIsRefetching,
              setSearchValue,
            )
            }
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            state={{
              columnFilters,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        }      
            <ToastDefault />
            </PageLayout>
        </Fragment>
    );
}

export default StaffManagement;